<script>
  import { onMount } from 'svelte'
  import { slide } from 'svelte/transition'
  import { fly } from 'svelte/transition'
  import { settings, cart, createWritableStore } from '../src/data_storage.js'
  settings.useLocalStorage()
  cart.useLocalStorage()

  import { _ } from 'svelte-i18n'

  import { formatCurrency } from '../src/utils'
  import KichList from './kich_list.svelte'
  import KichDetail from './kich_detail.svelte'
  import { scrollPosition } from 'svelte-scrolling'

  export let shop
  export let kich = null

  let featuredKiches = []
  let normalKiches = []

  let currentKich
  let showDetail = false
  let showAll = false

  const yScroll = createWritableStore('yScroll', 0)
  yScroll.useLocalStorage()

  function filterKiches() {
    //console.log("BfeaturedKiches " + featuredKiches.length)
    //console.log("BnormalKiches " + normalKiches.length)
    if ($cart[shop.id].items) {
      const cartItemsIds = cartItemsCount > 0 ? $cart[shop.id].items.map((item) => item.id) : []
      featuredKiches = featuredKiches.filter((featuredKich) => !cartItemsIds.includes(featuredKich.id))
      normalKiches = normalKiches.filter((normalKich) => !cartItemsIds.includes(normalKich.id))
    }
    //console.log("AfeaturedKiches " + featuredKiches.length)
    //console.log("AnormalKiches " + normalKiches.length)
  }

  function reloadKiches() {
    // console.log('shop reloadKiches')
    let count = 1
    featuredKiches = []
    normalKiches = []
    for(const kichbox of shop.kichboxes) {
      for(const kich of kichbox.kiches) {
        if (count <= 9) {
          featuredKiches.push(kich)
        } else {
          normalKiches.push(kich)
        }
        count = count + 1
      }
    }
    featuredKiches = featuredKiches
    normalKiches = normalKiches
    filterKiches()
  }

  function mountFromData(data, pushState = false) {
    // console.log(data)
    reloadKiches()
  }

  function loadSettings() {
    showAll = $cart.showAll
  }

  function saveSettings() {
    $cart.showAll = showAll
  }

  onMount(async () => {
    // console.log('shop onMount' + shop.slug)
    mountFromData(shop)
    if (kich) {
      currentKich = kich
      showDetail = true
    }
    loadSettings()

    // console.log("MfeaturedKiches " + featuredKiches.length)
    // console.log("MnormalKiches " + normalKiches.length)
  })

  function handle_add_to_cart(kich) {
    console.log("handle_add_to_cart")
    //filterKich(kich)
  }

  function handle_remove_from_cart(kich) {
    console.log("handle_from_from_cart")
    //filterKiches()
  }

  function handle_back() {
    showDetail = false
    currentKich = null
    showAll = true
    if ($yScroll){
      console.log('scrolling to ' + $yScroll)
      scrollPosition($yScroll)
    }
  }

  function show_all() {
    showAll = !showAll

    saveSettings()
  }

  function handle_choose(kich) {
    currentKich = kich
    showDetail = true
  }

  let cartItemsCount = 0
  let cartItemsCountPrev = 0
  $: cartItemsCount = $cart[shop.id].items ? $cart[shop.id].items.length : 0
  $: {
    //console.log("cartItemsCount " + cartItemsCount + ' prev:' +cartItemsCountPrev)
    if (cartItemsCount !== cartItemsCountPrev) {
      reloadKiches()
      cartItemsCountPrev = cartItemsCount
    }
  }
</script>
<div class="flex flex-col mb-16 mx-2 sm:mx-2">
  {#if showDetail}
    <KichDetail {shop} kich={currentKich} back_handler={handle_back} add_to_cart_handler={handle_add_to_cart}/>
  {:else}
    <div class="m-1 flex flex-row justify-center">{shop.meta_description || 'Welcome!'}</div>

    <KichList kiches={featuredKiches} choose_handler={handle_choose} bind:scroll={showDetail}/>
    {#if showAll}
      <KichList kiches={normalKiches} choose_handler={handle_choose} bind:scroll={showDetail}/>
    {:else}
      <div class="mt-3"><button class="btn" on:click={show_all}>{$_('btn.show_all')}</button></div>
    {/if}
  {/if}
</div>